import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validator, Validators } from '@angular/forms';

import { RegexConstants } from '../../../../../libs/constants/regex-constants';

import { MatFormFieldControl } from '@angular/material/form-field';
import { TextInputComponent } from './text-input.component';

@Component({
  selector: 'wz-mail-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: false,
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: MailInputComponent,
    },
    {
      provide: TextInputComponent,
      useExisting: MailInputComponent,
    },
  ],
})
export class MailInputComponent
  extends TextInputComponent
  implements Validator, OnInit, OnDestroy
{
  override get controlType() {
    return 'wz-mail-input';
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  validate(fc: FormControl) {
    let validatorFn = Validators.pattern(RegexConstants.Mail);
    return validatorFn(fc);
  }
}
